import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { Events } from '../core/events'
import debounce from 'lodash/debounce'

import { Accordion } from '../modules/accordion'

// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {
		// this.matchMedia = new MqlMatchMedia(`(min-width:${window.ctx.breakpoints.MEDIUM}px)`, (match) => {
		// 	console.log('aaiaiai')
		// 	this.destroyAccordion()
		// 	if (match) {
		// 		this.initAccordion()
		// 	}
		// 	// if (this.slider) this.slider.destroy()
		// 	// if (match) {
		// 	// 	this.renderSlider(this.tmplSliderPortrait)
		// 	// } else {
		// 	// 	this.renderSlider(this.tmplSliderLandscape)
		// 	// }

		// 	// this.initSlider()
		// })

		this.initAccordion()
	}
	mount() {}
	unmount() {}
	//
	initAccordion() {
		this.debouncedOnChange = debounce(() => {
			EventBus.emit(Events.PAGE_RESIZE)
		}, 500)

		this.accordion = new Accordion(this.element, {
			onChanged: this.debouncedOnChange,
		})
	}
	destroyAccordion() {
		if (this.accordion) {
			this.accordion.destroy()
		}
	}
}
